import React, { useState, useRef } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { Link } from "react-router-dom";
import right_arrow from "../../assets/images/icon/right-arrow-table.svg";
import left_arrow from "../../assets/images/icon/arrow-btn.svg";
import arrow1 from "../../assets/images/icon/arrow-1.svg";
import { Trans, useTranslation } from "react-i18next";

const TimeToHire = props => {
  const { t } = useTranslation();
  let data = props?.data;
  if (props?.type === "dashboard") {
    data = data?.slice(0, 5);
  }

  const columns = [
    {
      dataField: "title",
      text: t(`Dashboard.Job Title`),
      classes: "job-title pendinguser-cardss text-left",
      headerClasses: "text-left pendinguser-cardss",
      formatter: (cellContent, row) => {
        const title = row?.title;
        return (
          <div className="date-tabel">
            <Link
              to={`/all-applications?job_title=${row?.id}&filterValue=true`}
            >
              {title}
            </Link>
          </div>
        );
      },
    },
    {
      dataField: "minDays",
      text: t(`Dashboard.Min Time`),
      classes: "min text-center",
      headerClasses: "text-center",
    },
    {
      dataField: "maxDays",
      text: t(`Dashboard.Max Time`),
      classes: "Shortlisted-qaq text-cente pendinguser-cards",
      headerClasses: "text-center pendinguser-cards",
    },
    {
      dataField: "averageDays",
      text: t(`Dashboard.Average`),
      classes: "Shortlisted-fto-f text-cente pendinguser-cards avarages",
      headerClasses: "text-center pendinguser-cards",
    },

    // Add more columns as needed
  ];

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {t(`Dashboard.Showing rows`, { from, to, size })}
    </span>
  );
  let options = {
    paginationSize: 1,
    pageStartIndex: 1,
    alwaysShowAllBtns: true, // Always show next and previous button
    withFirstAndLast: true, // Hide the going to First and Last page button
    hideSizePerPage: true, // Hide the sizePerPage dropdown always
    hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: false,
    prePageText: false,
    nextPageText: false,
    lastPageText: false,
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: false,
  };
  const rowClasses = (row, rowIndex) => {
    return rowIndex % 2 === 0 ? "even-row" : "odd-row";
  };

  //tablewrapperref
  const tableWrapperRef = useRef(null);
  const handleScroll = direction => {
    if (tableWrapperRef.current) {
      const scrollAmount = 100; // Adjust this value as needed
      tableWrapperRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="vacancy-tabel timetohires">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12 d-flex align-items-center justify-content-between">
            <div className="eligible-content mt-2  ">
              <h3 className="d-flex align-items-center gap-2 heading-one">
                {t(`Dashboard.Time to Hire`)}
              </h3>
            </div>

            <div className="tale-text right-panel m-0">
              <button
                className="button left"
                onClick={() => handleScroll("left")}
                data-tooltip="Scroll Left"
              >
                <img src={right_arrow} alt="right-arrow" />
              </button>
              <button
                className="button right"
                onClick={() => handleScroll("right")}
                data-tooltip="Scroll Right"
              >
                <img src={right_arrow} alt="right-arrow" />
              </button>
            </div>
          </div>
          <div className="col-lg-12 ">
            <div className="timeto-hire-card userlist">
              <div className="tabel-application tabel-application-auto table-responsive pb-3  center-content-s">
                {
                  <div className="table-custome-class range-custome">
                    <div className="scroll-container">
                      {data?.length > 0 && (
                        <div className="table-wrapper" ref={tableWrapperRef}>
                          <BootstrapTable
                            keyField="id"
                            data={data}
                            columns={columns}
                            pagination={paginationFactory(options)}
                            rowClasses={rowClasses}
                          />
                        </div>
                      )}

                      {data?.length === 0 && (
                        // <p className="text-center">No Data Available.</p>
                        <div className="no-data data-available">
                          <img
                            src="../img/data-not-available.png"
                            alt="data not availble"
                          />
                          <h3>{t(`Dashboard.No Item Found`)}</h3>
                          <p>
                            <Trans>{t(`Dashboard.No Item Msg`)}</Trans>
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TimeToHire;
